export default __webpack_public_path__ + "static/media/user_avatar_2.b37620ec.png";